import { useEffect, useState } from 'react';
import { DSTextInput } from '@eiv2/design-system';

export interface SourceFilterProps {
  value: string;
  onChange: (next: string) => void;
  className?: string;
  /** Largura reduzida, alinhada aos campos de data. */
  compact?: boolean;
}

export function SourceFilter({ value, onChange, className, compact = false }: SourceFilterProps) {
  const [draft, setDraft] = useState(value);

  useEffect(() => {
    setDraft(value);
  }, [value]);

  useEffect(() => {
    const id = window.setTimeout(() => {
      if (draft !== value) onChange(draft);
    }, 300);
    return () => window.clearTimeout(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [draft]);

  return (
    <DSTextInput
      className={[compact ? 'min-w-0 w-full flex-1' : undefined, className]
        .filter(Boolean)
        .join(' ')}
      classNames={
        compact
          ? {
              field: 'min-h-14 bg-light-gray'
            }
          : undefined
      }
      label="Origem"
      onChange={(e) => setDraft(e.target.value)}
      placeholder="checkout-v2…"
      value={draft}
    />
  );
}
